import React from 'react';
import Icon from './Icon';
import { useUser } from '../hooks/useUser';
import { sign_in, sign_up } from '../../client/utility/outsetaLinks';

export default function Error({ error, type = 'generic' }) {
  console.error(error);

  const { user } = useUser();

  return (
    <>
      {type === 'generic' && (
        <div className="w-full py-48 sm:py-64 text-center flex flex-col justify-center items-center">
          <p
            className="text-3xl text-center mx-auto text-primary"
            aria-hidden="true"
          >
            <Icon icon="FiAlertTriangle" classes="text-7xl" />
          </p>
          <h3 className="mt-2 text-md font-medium text-neutral-900">
            Something went wrong
          </h3>
          <p className="mt-3 text-base text-neutral-500 w-64 text-center">
            It is possible the URL is invalid, or you do not have permission to
            view this page. Please try again later.
          </p>
        </div>
      )}
      {type === 'sharing' && (
        <div className="w-full py-40 text-center flex flex-col justify-center items-center">
          <Icon icon="FaGlobeAmericas" classes="text-7xl text-primary" />
          <h3 className="mt-4 text-md font-medium text-neutral-900">
            Something went wrong viewing this shared property.
          </h3>
          <p className="mt-3 text-base text-neutral-500 max-w-sm text-center">
            {!user && (
              <span>
                If you are the owner of this property or received a link to this
                page, please{' '}
                <a className="font-medium text-primary" href={sign_in}>
                  login
                </a>{' '}
                or{' '}
                <a className="font-medium text-primary" href={sign_up}>
                  sign up
                </a>{' '}
                to view the property.
              </span>
            )}
            {user && (
              <span>
                You may not have permission to view this property. Please
                contact the owner of this property for more information. If you
                just logged in, please refresh the page.
              </span>
            )}
          </p>
        </div>
      )}
    </>
  );
}
